import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';

// Sample images - Ces images sont utilisées comme valeur par défaut
const defaultImages = [
  '/images/avatar1.webp',
  '/images/avatar2.webp',
  '/images/avatar3.webp',
  '/images/avatar4.webp',
  '/images/avatar5.webp',
  '/images/avatar6.webp',
  '/images/avatar7.webp',
  '/images/avatar8.webp',
  '/images/avatar9.webp',
  '/images/avatar10.webp',
  '/images/avatar11.webp',
  '/images/avatar12.webp',
  '/images/avatar13.webp',
  '/images/avatar14.webp',
  '/images/avatar15.webp',
  '/images/avatar16.webp',
  '/images/avatar17.webp',
  '/images/avatar18.webp',
  '/images/avatar19.webp',
  '/images/avatar20.webp',
  '/images/avatar21.webp',
  '/images/avatar22.webp',
  '/images/avatar23.webp',
  '/images/avatar24.webp',
  '/images/avatar25.webp',
  '/images/avatar26.webp',
  '/images/avatar27.webp',
  '/images/avatar28.webp',
  '/images/avatar29.webp',
  '/images/avatar30.webp',
  '/images/avatar31.webp',
  '/images/avatar32.webp',
  '/images/avatar33.webp',
];

const ImageCarousel = ({ images = defaultImages, rowCount = 4, imagesPerRow = 8 }) => {
  const [rowData, setRowData] = useState([]);
  
  useEffect(() => {
    // Create a clean distribution of images
    distributeImages();
  }, [images]); // Réagir au changement de la prop images
  
  // Function to distribute images where each image is used exactly once
  const distributeImages = () => {
    // Make a copy and shuffle the images
    const availableImages = [...images];
    for (let i = availableImages.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [availableImages[i], availableImages[j]] = [availableImages[j], availableImages[i]];
    }
    
    // Create rows with distributed images
    const newRows = [];
    let imageIndex = 0;
    
    for (let i = 0; i < rowCount; i++) {
      // Create the row with its images (each image used only once)
      const rowImages = [];
      for (let j = 0; j < imagesPerRow && imageIndex < availableImages.length; j++) {
        rowImages.push(availableImages[imageIndex]);
        imageIndex++;
      }
      
      newRows.push({
        direction: i % 2 === 0 ? 'right' : 'left',
        images: rowImages
      });
    }
    
    setRowData(newRows);
  };
  
  return (
    <div className="image-carousel">
      {rowData.map((row, rowIndex) => (
        <div key={rowIndex} className={`image-row ${row.direction}`}>
          {/* Original images */}
          {row.images.map((image, imageIndex) => (
            <div key={`${rowIndex}-${imageIndex}`} className="image-container">
              <img src={image} alt={`AI Avatar ${imageIndex + 1}`} />
            </div>
          ))}
          
          {/* Duplicate for smooth scrolling - same images repeated */}
          {row.images.map((image, imageIndex) => (
            <div key={`${rowIndex}-dup1-${imageIndex}`} className="image-container">
              <img src={image} alt={`AI Avatar ${imageIndex + 1}`} />
            </div>
          ))}
          
          {/* Second duplicate for longer rows */}
          {row.images.map((image, imageIndex) => (
            <div key={`${rowIndex}-dup2-${imageIndex}`} className="image-container">
              <img src={image} alt={`AI Avatar ${imageIndex + 1}`} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ImageCarousel; 